<template>
  <div :style="mine">
    <van-row class="mine">
      <!-- 头部内容 -->
      <van-col :span="24" @click="setting">
        <van-image
          round
          width="3.4rem"
          height="3.4rem"
          :src="headImg"
          class="f-l-l"
        />
        <div class="f-l-l m-l-1">
          <van-row>
            <van-col>
              <p class="fontSty m-t-045">
                {{ userInfo == undefined ? "注册/登录" : userInfo.uname }}
              </p>
              <p class="fontSty m-t-3" v-if="userInfo != undefined">
                UID:{{ userInfo.uid }}
              </p>
            </van-col>
          </van-row>
        </div>
        <div class="f-l-r">
          <van-icon name="arrow" color="white" class="m-t-14" />
        </div>
      </van-col>
      <!-- 订单和优惠卷 -->
      <van-col :span="24" class="m-t-10">
        <OrderCoupon />
      </van-col>
      <!-- 菜单栏和列表 -->
      <van-col :span="24" class="m-t-15">
        <DataList />
      </van-col>
    <Footer></Footer>
      
    </van-row>

  </div>
</template>

<script>
import OrderCoupon from "@/components/mine/orderCoupon/orderCoupon";
import DataList from "@/components/mine/dataList/dataList";
import Footer from '@/components/footer'

export default {
  components: {
    OrderCoupon,
    DataList,
    Footer
  },
  data() {
    return {
      mine: {
        background:
          "url(" + require("@/assets/imgs/mineBackGround.png") + ") no-repeat",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      },
    };
  },
  methods: {
    setting() {
      if (localStorage.getItem("setToken") == null) {
        this.goLogin();
      } else {
        this.$router.push("/setting");
      }
    },
  },
  computed: {
    userInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    headImg() {
      // let img = ''
      if (this.userInfo == undefined) {
        return require("@/assets/imgs/user.png");
      } else {
        let imgSrc = this.userInfo.headimgurl;
        let localSrc = require("@/assets/imgs/user.png");
        return imgSrc != null ? imgSrc : localSrc;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mine {
  padding: 0.7rem 0.95rem;
}
.fontSty {
  color: #ffffff;
  font-size: 0.9rem;
}
</style>
